// extracted by mini-css-extract-plugin
module.exports = {"container":"registration-form_container__rP8e2"};